import { withNamespaces } from 'react-i18next';

import getStateVisuals from './stateVisuals';
import NodeHandles from './NodeHandles';

const DecisionNode = ({
    data,
    t,
}) => {
    const visuals = getStateVisuals(data.state);
    const isDecided = data.state !== 'pending' && data.state !== 'processing';

    return (
        <>
            <NodeHandles />

            <div className="live-verification-box text-center p-3" style={{ width: 160 }}>
                <i className={`${visuals.icon} text-${visuals.color} font-size-18`} />
                <div className="font-size-11 text-muted mt-1">{t(data.label)}</div>
                <div className={`font-size-12 fw-bold text-${visuals.color}`}>
                    {t(isDecided ? data.detail : 'Awaiting analysis')}
                </div>
            </div>
        </>
    );
};

export default withNamespaces()(DecisionNode);
